import { generateUUID } from '@mmt/navigation/src/util';
import { getJourneyId, logRailsEventToPDT, buildEnrichedSearchContext } from '../PdtV2Utils';
import { GFT_PDT_EVENTS_TYPE } from './PdtGftConstants';
import { searchContextMapper } from '../PdtCtRailsListing';
import { COMMON_EVENT_TRACKING_CONTEXT, COMMON_PDT_CONSTANTS } from '../CommonPdtConstants';
import { PDT_SCHEMA_ID, PDT_SCHEMA_NAME } from '../PdtCtRailsListing/PdtCtConstants';

interface ErrorDetailsType {
  errorCode: string;
  errorMessage: string;
}

export const logGftPageEventsToPdt =
  (eventValue: GFT_PDT_EVENTS_TYPE, errorDetails: ErrorDetailsType) =>
  async (dispatch, getState) => {
    try {
      const state = getState() || {};
      const searchContext = await buildEnrichedSearchContext(state);

      const event_detail = {
        event_id: generateUUID(),
        event_timestamp: Date.now(),
        event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
        event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
        components: {
          id: '',
        },
        ...eventValue,
      };

      const errorDetailsObj = {
        code: errorDetails?.errorCode || '',
        message: errorDetails?.errorMessage || '',
      };

      const pdtLoggerObj = {
        error_details_list: errorDetails ? [errorDetailsObj] : null,
        page_context: {
          lob: 'rails',
          page_name: eventValue?.page_name === 'gft' ? 'gft_page' : 'irctcWebview',
        },
        event_tracking_context: {
          ...(await COMMON_EVENT_TRACKING_CONTEXT()),
          template_id: PDT_SCHEMA_ID,
          topic_name: PDT_SCHEMA_NAME,
          ...(await getJourneyId(searchContext)),
        },
        search_context: searchContextMapper(searchContext),
        event_detail,
      };
      logRailsEventToPDT(pdtLoggerObj);
    } catch (error) {
      console.error('Error in logging GFT PDT event', error);
    }
  };
